import React from "react";
import './header.css'
import CTA from './CTA'
import HeaderSocials from "./HeaderSocials";

const Header = () => {
    return (
        <header>
            <div className="header__bg-grid" aria-hidden="true"></div>
            <div className="header__glow" aria-hidden="true"></div>
            <div className="header__scan" aria-hidden="true"></div>

            <div className="container header__container">
                <div className="term-window header__term">
                    <div className="term-titlebar">
                        <span className="term-dot red"></span>
                        <span className="term-dot yellow"></span>
                        <span className="term-dot green"></span>
                        <span className="term-path">sumit@portfolio: ~</span>
                    </div>
                    <div className="term-body header__body">
                        <p className="mono txt-muted">{"// initializing profile…"}</p>
                        <p className="mono"><span className="txt-green">$</span> whoami</p>
                        <h1 className="header__name">Sumit Kumar</h1>
                        <p className="mono header__line">
                            <span className="txt-cyan">const</span> role ={" "}
                            <span className="txt-green">"</span>
                            <span className="header__type header__type-1">Senior Backend &amp; Data Engineer</span>
                            <span className="txt-green">"</span>
                        </p>
                        <p className="mono header__line">
                            <span className="txt-cyan">const</span> exp&nbsp; ={" "}
                            <span className="txt-amber header__type header__type-2">7+ years · terabyte-scale</span>
                        </p>
                        <p className="mono">
                            <span className="txt-green">$</span> cat stack.txt
                            <span className="header__cursor"></span>
                        </p>
                        <div className="header__chips header__fade header__fade-1">
                            <span className="chip">Python</span>
                            <span className="chip">ClickHouse</span>
                            <span className="chip">Trino</span>
                            <span className="chip">Iceberg</span>
                            <span className="chip">Kubernetes</span>
                            <span className="chip">LLMs</span>
                        </div>
                        <div className="header__fade header__fade-2">
                            <CTA/>
                        </div>
                    </div>
                </div>
            </div>

            <HeaderSocials/>
            <a href="#contact" className="scroll__down mono">scroll ↓</a>
        </header>
    )
}

export default Header
